"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styling = require("../toolkit/styling");

var icons = _interopRequireWildcard(require("../toolkit/icons"));

var _string = require("../toolkit/string");

//
//  src/Icon.tsx
//  Project-Lego
//
//  Created by Richard Ye on 12/04/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var propDoc = {
  name: {
    required: true,
    type: "IconName",
    description: "Name of the icon to display. Icons should be defined in the " + "`lego/toolkit/icons.tsx` file. You can look up names on the " + "[Iconography page](/lego/icons/marketplace)."
  },
  alt: {
    required: false,
    type: "string",
    description: "Text alternative for the image, to support accessibility and search " + "engines. If blank, a human-readable version of the name will be used."
  }
};
var demoProps = {
  name: "arrowLeft",
  alt: "Leftward Arrow"
};

var Icon = function Icon(props) {
  var alt = props.alt,
      name = props.name,
      className = props.className,
      style = props.style,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["alt", "name", "className", "style"]);
  var iconSrc = icons[name];

  if (iconSrc == null) {
    return null;
  }

  var Content = function Content() {
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: iconSrc,
      alt: alt || (0, _string.toSentenceCase)(name),
      draggable: false,
      style: {
        width: "100%",
        height: "100%"
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _styling.css)(className, style)
  }, otherProps), /*#__PURE__*/_react["default"].createElement(Content, null));
};

Icon.propDoc = propDoc;
Icon.demoProps = demoProps;
var _default = Icon;
exports["default"] = _default;